import QueryString from "qs";
import {isLoggedIn, logout, getAndStoreToken} from "../auth";

const axios = require("axios");
export const WSInstance = axios.create({
  paramsSerializer: (params) =>
    QueryString.stringify(params, { arrayFormat: "repeat" }),
});

WSInstance.interceptors.request.use(
  async (request) => {
    request.headers["x-auth-token"] = localStorage.getItem("token");
    logRequest(request);
    return request;
  },
  (error) => {
    Promise.reject(error);
  }
);



WSInstance.interceptors.response.use(
  (response) => {   
    //console.log("RESPONSE - SUCCESS - "+`${response.config.method.toUpperCase()} ${response.config.url}`);
    //console.log(response.data);
    //logResponse(response); 
    return response;
  },
  async function (error) {    
    //console.log("RESPONSE - ERROR - "+`${error.response.config.method.toUpperCase()} ${error.response.config.url}`);
    //console.log("RESPONSE - ERROR: ", error);

    const originalRequest = error.config;
    if (error.response) {
      if (error.response.status === 401) {
        try {
          await getAndStoreToken();
          return WSInstance.request(originalRequest);
        } catch (err) {
          if (isLoggedIn()) {
            logout();
          }
          throw err;
        }
      } else {
        throw error.response;
      }
    }
    Promise.reject(error);
  }
);



const logRequest = (request, type = 'default', message = 'REQUEST') => {
  const headers = {
    ...request.headers.common, 
    ...request.headers[request.method], 
    ...request.headers 
  };
  //remove unrelevant headers to reduce noise 
  ['common', 'get', 'post', 'head', 'put', 'patch', 'delete'].forEach(
    header => delete headers[header]
  )

  let printableRequest=`${message}`;
  try {
    switch(type){
      case "original":
        printableRequest = `${new Date().toJSON()} | Request: ${request.method.toUpperCase()} | ${request.url} | ${JSON.stringify(request.data)} | ${JSON.stringify(headers)}`;
        break;
      case "custom":
        printableRequest = `${message} | Request: ${request.method.toUpperCase()} ${request.url} | Headers: [${JSON.stringify(headers)}] | Data: [${JSON.stringify(request.data)}]`;
        break;
      default:
        printableRequest = `REQUEST - ${request.method.toUpperCase()} ${request.url}`;    
    }
    
  } catch (error) {
    console.error('error during printableRequest', error);
  }
  //console.log(printableRequest);  
  }

const logResponse = (response) => {
    let responseLog = `RESPONSE - Request: ${response.config.method.toUpperCase()} ${response.config.url} | Status: ${response.status} | Data: [${JSON.stringify(response.data)}]`;
    console.log(responseLog);
    /*
    console.log(response.data);
    console.log(response.status);
    console.log(response.statusText);
    console.log(response.headers);
    console.log(response.config);
    */
}
